import {
	createContext,
	useContext,
	useState,
	useEffect,
	useCallback,
} from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import styles from "./UpdateContext.module.css"; // Assuming you have some styles for the modal

const UpdateContext = createContext();

export const UpdateProvider = ({ children }) => {
	const [showUpdateModal, setShowUpdateModal] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		const hasSeenUpdate = localStorage.getItem("hasSeenUpdate");
		if (!hasSeenUpdate) {
			setShowUpdateModal(true);
		}
	}, []);

	const handleClose = useCallback(() => {
		setShowUpdateModal(false);
		localStorage.setItem("hasSeenUpdate", "true");
	}, []);

	return (
		<UpdateContext.Provider value={{ showUpdateModal, setShowUpdateModal }}>
			{children}
			<Modal show={showUpdateModal} onHide={handleClose} centered size="lg">
				<Modal.Header closeButton>
					<Modal.Title>🎉 New Features!</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>
						Our new custom video feature gives you the power to create
						professional videos with ease. Here's what's new:
					</p>
					<ul>
						<li>
							🎥 Custom Video Creation: Upload your own videos, images, and
							logos.
						</li>
						<l1>🎬 One on one service with a professional video producer.</l1>
						<li>
							🔍 Video Preview: Iterate on multiple versions until you are
							satisfied.
						</li>
					</ul>
					<div className={styles.videoContainer}>
						<iframe
							src="https://drive.google.com/file/d/14I63NrOI2J55z7T-OIECcZ_WGPBehVnh/preview"
							allow="encrypted-media"
							allowFullScreen
							title="Tutorial Video"
							className={styles.videoFrame}
						></iframe>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						onClick={() => {
							handleClose();
							navigate("/tickets");
						}}
					>
						Go to Custom Videos
					</Button>
				</Modal.Footer>
			</Modal>
		</UpdateContext.Provider>
	);
};

export const useUpdateContext = () => {
	return useContext(UpdateContext);
};
